import { render, staticRenderFns } from "./_ListaImpressora.vue?vue&type=template&id=2c58bc2e&scoped=true&"
import script from "./_ListaImpressora.vue?vue&type=script&lang=js&"
export * from "./_ListaImpressora.vue?vue&type=script&lang=js&"
import style0 from "./_ListaImpressora.vue?vue&type=style&index=0&id=2c58bc2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c58bc2e",
  null
  
)

export default component.exports